import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=4395f4b1&scoped=true"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"
import style0 from "./Picture.vue?vue&type=style&index=0&id=4395f4b1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395f4b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4395f4b1')) {
      api.createRecord('4395f4b1', component.options)
    } else {
      api.reload('4395f4b1', component.options)
    }
    module.hot.accept("./Picture.vue?vue&type=template&id=4395f4b1&scoped=true", function () {
      api.rerender('4395f4b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/Picture.vue"
export default component.exports